import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as filesPlayground from '../../files-playground'

export const RESOURCE = {
  payload: {
    description: 'Sandbox entity for manually testing the Files attribute',
    dimension: filesPlayground.RESOURCE.payload,
    level: 1,
    name: 'Files Demo',
    partialId: PartialId.Standard.create('files_demo'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
